import { Component, Inject, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { HomeController } from '@shared/src/controllers/home/home.controller';
import { RouteController } from '@shared/src/controllers/route/route.controller';
import { AcquireRouteWizardCtrlDto } from '@shared/src/dtos/route/acquire/AcquireRouteWizardCtrlDto';
import { PartnerAcquireRouteItemDto } from '@shared/src/dtos/route/acquire/PartnerAcquireRouteItemDto';

@Component({
	selector: 'shared-route-acquire-wizard-selectpartner',
	templateUrl: './shared.route.acquire.wizard.selectpartner.html',
	styleUrls: ['./shared.route.acquire.wizard.selectpartner.scss']
})
export class SharedRouteAcquireWizardSelectPartner implements OnInit {

	public useIonic: boolean = false;
	constructor(public routeController: RouteController,
		@Inject('HomeController') protected homeController: HomeController) {

		if (homeController.useIonic)
			this.useIonic = homeController.useIonic();

	}

	ngOnInit(): void {
		this.loadData();
	}

	public _wizard: AcquireRouteWizardCtrlDto;
	@Input()
	public get wizard(): AcquireRouteWizardCtrlDto {
		return this._wizard;
	}
	public set wizard(value: AcquireRouteWizardCtrlDto) {
		if (this._wizard === value)
			return;
		this._wizard = value;
	}

	public partners: Array<PartnerAcquireRouteItemDto> = [];
	loadData() {

		this.partners = [];
		this.routeController.getWizardAcquireRoutesPartners(false).subscribe(e => {
			this.partners = e;
		});
	}

	@Output()
	partnerSelected: EventEmitter<PartnerAcquireRouteItemDto> = new EventEmitter<PartnerAcquireRouteItemDto>();


	onSelectPartner(item: PartnerAcquireRouteItemDto) {
		if (this.wizard == null)
			return;
		this.wizard.selectedPartner = item;
		this.wizard.calculateInternalData();
		this.partnerSelected.next(item);
	}

}
